import { ManagementLoginApprovalApiRepository } from "@/app/infrastructures/repositories/api/ManagementLoginApprovalApiRepository";
import { LoginApprovalDeleteReviewBody, LoginApprovalDeviceRequest, LoginApprovalDevicesList, LoginApprovalHistoryList, LoginApprovalHistoryRequest, LoginApprovalList, LoginApprovalRequest, LoginReviewBody } from "@/domain/entities/ManagementLoginApproval";
import { ResponsePayloadV2 } from "@/domain/entities/ResponsePayload";
import { injectable } from "tsyringe";

@injectable()
export class ManagementLoginApprovalPresenter {
  private repository: ManagementLoginApprovalApiRepository;

  constructor(repository: ManagementLoginApprovalApiRepository) {
    this.repository = repository;
  }

  // approval
  getLoginApprovalList(params: LoginApprovalRequest): Promise<LoginApprovalList> {
    return this.repository.getLoginApprovalList(params);
  }

  postLoginApprovalReview(params: LoginReviewBody): Promise<ResponsePayloadV2> {
    return this.repository.postLoginApprovalReview(params);
  }

  // devices
  getLoginApprovalDevicesList(params: LoginApprovalDeviceRequest): Promise<LoginApprovalDevicesList> {
    return this.repository.getLoginApprovalDevicesList(params);
  }

  postLoginApprovalDeviceDelete(params: LoginApprovalDeleteReviewBody): Promise<boolean> {
    return this.repository.postLoginApprovalDeviceDelete(params);
  }

  // history
  getLoginApprovalHistoryList(params: LoginApprovalHistoryRequest): Promise<LoginApprovalHistoryList> {
    return this.repository.getLoginApprovalHistoryList(params);
  }
}
